var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { sm: "12", md: "12" } }, [
            _c("div", { staticClass: "upgrade-title" }, [
              _c(
                "div",
                { staticClass: "u-woops" },
                [
                  _c("div", { staticClass: "ico" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/logo_r.png"),
                        alt: "upgrade",
                      },
                    }),
                  ]),
                  _c("w-spacer"),
                  _c("span", { staticClass: "upgrade-info" }, [
                    _c("span", [_vm._v("Winfakt Starter")]),
                    _c("span", { staticClass: "price" }, [
                      _vm._v("20 "),
                      _c("span", { staticClass: "eur" }, [_vm._v("EUR")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct(
                              "components.account.pricing.short-per-month"
                            )
                          )
                      ),
                    ]),
                    _c("span", { staticClass: "more" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$ct("components.account.pricing.invoiced-yearly")
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c("w-col", { attrs: { sm: "12", md: "12" } }, [
            _c("div", { staticClass: "upgrade-header" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ct(
                      "components.common-MissingModule.out-of-documents-1"
                    )
                  )
                ),
              ]),
              _c("span", {
                directives: [
                  {
                    name: "safe-html",
                    rawName: "v-safe-html",
                    value: _vm.$ct(
                      "components.common-MissingModule.out-of-documents-2"
                    ),
                    expression:
                      "$ct('components.common-MissingModule.out-of-documents-2')",
                  },
                ],
                staticClass: "info",
              }),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { sm: "12", md: "6" } },
            [
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[0]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[1]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[2]"))
                ),
              ]),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "6" } },
            [
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[3]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[4]"))
                ),
              ]),
              _c("app-item-option", [
                _vm._v(
                  _vm._s(_vm.$ct("components.account.features.starter[5]"))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }